<template>
  <div>
    <!-- Image Fullscreen Preview -->
    <v-dialog v-model="filterDialog" maxWidth="450" persistent>
      <v-card class="pa-5 pt-6">
        <v-card-text class="pa-0">
          <div class="filter-buttons-container">
            <!-- Tüm gönderiler - Full width button -->
            <v-btn
              :color="selectedFilter === 'all' ? 'primary' : 'default'"
              :class="selectedFilter === 'all' ? 'white--text' : ''"
              block
              large
              class="mb-4 text-capitalize filter-button"
              @click="selectFilter('all')"
            >
              Tüm gönderiler
            </v-btn>

            <!-- Two half-width buttons -->
            <div class="filter-buttons-row">
              <!-- Kendi Bölümüm (Division) - Left button -->
              <v-btn
                :color="selectedFilter === 'division' ? 'primary' : 'default'"
                :class="['text-capitalize', selectedFilter === 'division' ? 'white--text' : '']"
                large
                class="filter-button-half"
                @click="selectFilter('division')"
              >
                Kendi Bölümüm
              </v-btn>

              <!-- Kendi Bölgem (Region) - Right button -->
              <v-btn
                :color="selectedFilter === 'region' ? 'primary' : 'default'"
                :class="['text-capitalize', selectedFilter === 'region' ? 'white--text' : '']"
                large
                class="filter-button-half"
                @click="selectFilter('region')"
              >
                Kendi Bölgem
              </v-btn>
            </div>
          </div>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue-grey"
            class="white--text text-capitalize"
            text
            rounded
            :disabled="filterLoading"
            @click="closeDialog()"
          >
            {{ $t('buttons.cancelUpper') }}
          </v-btn>
          <v-btn
            color="blue-grey"
            class="white--text text-capitalize mr-3"
            outlined
            rounded
            :loading="filterLoading"
            @click="applyFilter()"
          >
            {{ $t('buttons.filter') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <div class="filter-fixed-buttons">
      <v-btn
        v-if="this.filterAlertStatus"
        :loading="filterLoading"
        depressed
        dark
        color="blue-grey text-capitalize filter-badge-button"
        height="50"
        @click="deleteFilter"
      >
        {{ getFilterLabel() }}
        <v-icon right dark class="ml-2"> mdi-close-circle </v-icon>
      </v-btn>

      <v-btn
        @click="filterDialog = !filterDialog"
        height="50"
        dark
        class="px-0 filter-icon-button"
        elevation="0"
        color="defaultColorLightTwo"
        min-width="50"
      >
        <v-icon class="px-0">mdi-tune</v-icon>
      </v-btn>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import UserService from '../../services/UserService';

export default {
  data() {
    return {
      filterDialog: false,
      selectedFilter: 'all', // 'all', 'division', 'region'
      filterLoading: false,
      filterStatus: false,
      groupInfo: null, // Store division and region info
    };
  },
  props: {},
  components: {},
  mounted() {
    // Initialize selectedFilter from store state
    const state = this.$store.state;
    if (state.myDivision) {
      this.selectedFilter = 'division';
    } else if (state.myRegion) {
      this.selectedFilter = 'region';
    } else {
      this.selectedFilter = 'all';
    }
    
    // Fetch group info to get division and region names
    this.fetchGroupInfo();
  },
  methods: {
    selectFilter(filterType) {
      this.selectedFilter = filterType;
    },

    applyFilter() {
      let myRegion = false;
      let myDivision = false;

      if (this.selectedFilter === 'all') {
        myRegion = false;
        myDivision = false;
      } else if (this.selectedFilter === 'division') {
        myDivision = true;
        myRegion = false;
      } else if (this.selectedFilter === 'region') {
        myRegion = true;
        myDivision = false;
      }

      this.setFilterState({ myRegion, myDivision });
        this.filterLoading = true;
      this.getPosts({ myRegion, myDivision }).finally(() => {
          this.scrollTop();
          this.filterLoading = false;
        this.filterStatus = this.selectedFilter !== 'all';
          this.filterDialog = false;
        });
    },

    deleteFilter() {
      this.selectedFilter = 'all';
      this.applyFilter();
    },

    scrollTop() {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth',
      });
    },

    closeDialog() {
      // Reset to current filter state from store
      const state = this.$store.state;
      if (state.myDivision) {
        this.selectedFilter = 'division';
      } else if (state.myRegion) {
        this.selectedFilter = 'region';
      } else {
        this.selectedFilter = 'all';
      }
      this.filterDialog = false;
    },

    fetchGroupInfo() {
      UserService.getGroupInfo()
        .then((res) => {
          // API returns data in Result object
          this.groupInfo = res.data && res.data.Result ? res.data.Result : null;
        })
        .catch((err) => {
          console.error('Error fetching group info:', err);
          // Fallback to default labels if service fails
          this.groupInfo = null;
        });
    },

    getFilterLabel() {
      if (this.$store.state.myDivision) {
        // Use division name from groupInfo if available, otherwise fallback
        return (this.groupInfo && this.groupInfo.Division) || 'Kendi Bölümüm';
      } else if (this.$store.state.myRegion) {
        // Use region name from groupInfo if available, otherwise fallback
        return (this.groupInfo && this.groupInfo.Region) || 'Kendi Bölgem';
      }
      return '';
    },

    ...mapActions(['getPosts', 'setFilterState']),
  },
  computed: {
    filterAlertStatus() {
      return this.$store.state.myRegion || this.$store.state.myDivision;
    },
  },
};
</script>

<style scoped>
.filter-buttons-container {
  width: 100%;
}

.filter-buttons-row {
  width: 100%;
  display: flex;
  align-items: stretch;
  gap: 8px;
  margin: 0;
  padding: 0;
  margin-bottom: 10px;
}

.filter-button-half {
  flex: 1 1 calc(50% - 4px);
  min-width: 0;
  margin: 0 !important;
}

.filter-fixed-buttons {
  position: fixed;
  bottom: 16px;
  right: 20px;
  display: flex;
  align-items: center;
  gap: 8px;
  z-index: 1000;
}

.filter-icon-button {
  flex-shrink: 0;
}

.filter-badge-button {
  flex-shrink: 0;
  white-space: nowrap;
}

/* Ensure dialog has proper z-index */
/deep/ .v-dialog {
  z-index: 2000 !important;
}

/* Ensure buttons are properly aligned */
.filter-button {
  width: 100%;
}

/* Override Vuetify button styles for proper alignment */
.filter-buttons-row .v-btn {
  flex: 1 1 calc(50% - 4px);
  margin: 0 !important;
  width: auto;
}
</style>
